<template>
  <div class="search-keyword">
    <AppInputText
      :placeholder="placeholder"
      :maxLength="maxLength"
      class="search-keyword__input"
      :class="{
        'is-error': isError,
        'is-unset-button': !useSearchButton
      }"
      :value="text"
      @inputed="inputed"
    />
    <button
      v-if="useSearchButton"
      class="search-keyword__button"
      @click="clicked"
    >検索</button>
  </div>
</template>

<script>
import AppInputText from '@/components/elements/AppInputText/'
export default {
  components: {
    AppInputText
  },
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    maxLength: {
      type: Number,
      required: false,
      default: 100
    },
    isError: {
      type: Boolean,
      required: false,
      default: false
    },
    useSearchButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      text: this.value
    }
  },
  methods: {
    clicked() {
      this.$emit('clicked', this.text)
    },
    inputed(text) {
      this.text = text
      this.$emit('inputed', this.text)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.search-keyword {
  display: flex;

  &__input {
    border-color: $cool-gray-3;
    border-radius: .25rem 0 0 .25rem;
    border-style: solid;
    border-width: 1px 0 1px 1px;
    width: calc(100% - 3rem);

    &::placeholder {
      color: $cool-gray-4;
    }

    &.is-unset-button {
      border-radius: .25rem;
      border-width: 1px;
      width: 100%;
    }

    @include hover {
      outline: 2px solid $black;
      outline-offset: -2px;
    }

    @include focus {
      outline: 2px solid $black;
      outline-offset: -2px;
    }

    &.is-error {
      background-color: $error-bg;
      outline: 2px solid $error;
      outline-offset: -2px;
    }
  }

  &__button {
    background-color: $black;
    border-radius: 0 .25rem .25rem 0;
    color: $white;
    display: block;
    font-size: .75rem;
    width: 3rem;
  }
}
</style>